import axios from "axios";

/**
 *
 * @param {string} action
 * @param {string} value
 * @param {array|null} extra
 */
export function trackAction(action, value, extra = null) {
    axios
        .post("/t", {
            action: action,
            value: value,
            extra: extra,
        })
        .catch(function () {});
}

export function getExternalRedirectUrl(url) {
    return "/redirect/?url=" + encodeURIComponent(url);
}
